import { render, staticRenderFns } from "./classOpenServiceOne1.vue?vue&type=template&id=27bb4d99&scoped=true&"
import script from "./classOpenServiceOne1.vue?vue&type=script&lang=ts&"
export * from "./classOpenServiceOne1.vue?vue&type=script&lang=ts&"
import style0 from "./classOpenServiceOne1.vue?vue&type=style&index=0&id=27bb4d99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb4d99",
  null
  
)

export default component.exports